$(function () {
    /* global Modernizr:true */
    $('.close').click(function(){
       $('.pop-up').css('display', 'none');
    });

    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 481) {
            $('#subnavigation a').text('');
        }
    }

    var _this = this,
        _body = $('body');
    /**
     * Initialize
     */
    _this.init = function()
    {
        $('a[rel="external"]').attr('target', '_blank');

        $('.hamburger').on('click', function() {
            $('#navigation').toggleClass('open');
            $(this).toggleClass('open');
        });

        $(window).on("resize", function (e) {
            checkScreenSize();
        });

        checkScreenSize();
    };

    /**
     *  If body is not loaded, init
     */
    if (!_body.hasClass('loaded'))
    {
        _this.init();
    }
});
